// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".bundle." + {"105":"ae0dde040dc0676af2b8","740":"e15f3dd17c2fca5bf554"}[chunkId] + ".js";
};